import type { AxiosResponse } from "axios";
import type { HttpClient } from "@/services/baseClient";
import type { ApiResponse, UserLookupResult } from "@/types";

export function createUsersApi({ client }: HttpClient) {
  return {
    async lookupUserByEmail(email: string): Promise<UserLookupResult> {
      const response: AxiosResponse<ApiResponse<UserLookupResult>> =
        await client.get("/users/lookup", { params: { email } });
      return response.data.data;
    },
  };
}
